import { AxiosError } from 'axios';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_CREATE_SPECIAL_CONSIDERATION_NEW_APPLICATION_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { ExamLevelSeriesRequest } from './usePostCheckEligibility';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface NewApplicationResponse {
  uuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: NewApplicationResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCreateNewApplication = ({ onSuccess, onError }: Input = {}) => {
  const postCreateNewApplication = async (reqBody: ExamLevelSeriesRequest) => {
    const res = await axiosClient.post<NewApplicationResponse>(
      POST_CREATE_SPECIAL_CONSIDERATION_NEW_APPLICATION_URL,
      reqBody
    );
    return res.data;
  };

  return useCustomMutation(postCreateNewApplication, {
    onSuccess,
    onError,
  });
};
